import { render, staticRenderFns } from "./RightPaneTaskInfo.vue?vue&type=template&id=2f7fd5cf&"
import script from "./RightPaneTaskInfo.vue?vue&type=script&lang=js&"
export * from "./RightPaneTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./RightPaneTaskInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTextField,VTextarea})
